// 改成按需导入，减少打包体积
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import firmware from '@/upgrade/firmware'
import { isElectron } from '@libs/utils/envUtils'
import { DriverService } from './driver/driver'
import { DriverSocketMsgType } from '@libs/types/message'
import { DeviceManager, DeviceProtocol } from './device'

export class DeviceCapability {
  static async isRSSupported(): Promise<boolean> {
    return await firmware.versionIs20241125a()
  }

  static async isSupportKME(): Promise<boolean> {
    const fwVersionIs103 = await firmware.fwVersionGreaterThanOrEqual('1.0.3', firmware.fwVersionDvs1)
    const fwVersionIs100 = await firmware.fwVersionGreaterThanOrEqual('1.0.0', firmware.fwVersionDvs2)
    const fwVersion20250326 = await firmware.versionIs20250326()
    if (fwVersionIs103 || fwVersionIs100 || fwVersion20250326) {
      return true
    }
    if (specialCheckCurrent(speciaBehiver.SupportKME)) {
      return true
    }
    return false
  }
  /**
   * 判断火柴人设备是否满足音乐律动要求的固件版本 (>= 1.06)
   * 如果不是火柴人设备，则默认通过检查
   */
  static async isHuoChaiRenMusicSupported(): Promise<boolean> {
    // 如果不是火柴人系列设备，直接返回 true（不拦截）
    if (!specialCheckCurrent(speciaBehiver.DevicesOfHuoChaiRen)) {
      return true
    }
    // 火柴人方案需要检查固件版本
    return await firmware.isHuoChaiRenV106()
  }

  /**
   * 检查音乐律动是否可用
   * 同时检查设备硬件支持及服务连接状态
   */
  static async isMusicRhythmAvailable(): Promise<boolean> {
    // 0 如果是exe 适配的设备，都支持音乐律动功能
    if (DeviceManager.instance.state.driverProtocol == DeviceProtocol.dll_exe) {
      return true
    }
    // 1. 基础条件检查：是否在 Electron 环境且配置支持音乐律动
    const isBasicSupport = isElectron() && specialCheckCurrent(speciaBehiver.SupportMusicRhythmSupported)
    if (!isBasicSupport) return false

    // 2. 特殊设备（火柴人）固件版本检查
    if (!(await this.isHuoChaiRenMusicSupported())) return false

    // 3. 通信层检查：请求驱动服务确认律动状态
    return await DriverService.instance.askType<boolean>(DriverSocketMsgType.MTMusicalRhythmEnable)
  }

  static isKMEModeSupported = async () => {
    if (specialCheckCurrent(speciaBehiver.DevicesOfJingtai_V2) || specialCheckCurrent(speciaBehiver.DevicesOfHuoChaiRen)) {
      return true
    } else {
      const v1 = await firmware.versionIs20241125a()
      const v2 = await firmware.versionIs20250326()
      return v1 || v2
    }
  }
}
